module.exports = __webpack_public_path__ + "static/media/approved.db6f703e.svg";